import React from "react";
import ProjectCard from "../ProjectCard";
// import OngoingList from "../OngoingList";
import { completeddata } from "./CompletedData";
import PromenadeOngoingData from "./Promenade/PromenadeOngoingData";
function Ongoing({ projectOnClick = null }) {
  const promenadeOngoingData = PromenadeOngoingData();
  return (
    <section className="section-pad border-bottom">
      <div className="container-xl container-fluid">
        <h3 className="section-title">Commercial Projects</h3>
        <div className="row justify-content-center">
          {promenadeOngoingData?.filter(item => item && item.id).map((item) => {
            return (
              <div className="col-md-6 col-xl-4 mb-3" key={item.id}>
                <ProjectCard onClick={projectOnClick} {...item} />
              </div>
            );
          })}
          {completeddata?.filter(item => item && item.id).map((item) => {
            return (
              <div className="col-md-6 col-xl-4 mb-3" key={item.id}>
                <ProjectCard onClick={projectOnClick} {...item} />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Ongoing;
